var __rspack_ns_object = {"rE":"1.127.0"}